
<div class="wizard-container wizard-sdv">
  <!-- Step Indicators -->
  <ul class="wizard-steps" *ngIf="(isHandset$ | async) === false">
    <li *ngFor="let step of relevantSteps; let i = index" [class.active]="i === currentStepIndex">
      {{ step.label | translate }}
    </li>
  </ul>

  <!-- Step Content -->
  <div class="wizard-content card">
    <ng-container [ngSwitch]="currentStepIndex">
      <h1 *ngIf="(isHandset$ | async)" class="fs-3 fw-bold m-3">
        {{ steps[currentStepIndex].label | translate }}
      </h1>
      <form>
        <app-step1-profile-check-form-sdv
          *ngSwitchCase="0"
          #step1
          (profileCheckFormValid)="setProfileCheckFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        ></app-step1-profile-check-form-sdv>

        <app-step2-requirements-check-form-sdv
          *ngSwitchCase="1"
          #step2
          (requirementsCheckFormValid)="setRequirementsCheckFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        ></app-step2-requirements-check-form-sdv>

        <app-step3-requirements-info-page-sdv
          *ngSwitchCase="2"
          #step3
          (stepLoaded)="loadingStepComplete()"
        >
        </app-step3-requirements-info-page-sdv>

        <app-step4-test-time-form-sdv
          *ngSwitchCase="3"
          #step4
          (timeSlotFormValid)="setTimeSlotFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
          [stepId]="stepId"
        ></app-step4-test-time-form-sdv>

        <app-step5-pricing-sdv
          *ngSwitchCase="4"
          #step5
          (pricingFormValid)="setPricingFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        ></app-step5-pricing-sdv>

        <app-step6-additional-questions-form-sdv
          *ngSwitchCase="5"
          #step6
          (additionalQuestionsFormValid)="setAdditionalQuestionsFormValid($event)"
          (stepLoaded)="loadingStepComplete()"
        ></app-step6-additional-questions-form-sdv>

        <app-step7-booking-overview-sdv
          *ngSwitchCase="6"
          #step7
          (stepLoaded)="loadingStepComplete()"
        ></app-step7-booking-overview-sdv>
      </form>
    </ng-container>
  </div>

  <!-- Navigation Controls -->
  <div class="d-flex justify-content-between">
    <div>
      <button
        *ngIf="!isFirstStep"
        class="btn btn-outline-primary me-3 mb-3"
        (click)="previousStep()"
        [disabled]="stepLoading">
        {{ 'button.back' | translate }}
      </button>
      <button
        *ngIf="!isLastStep"
        class="btn btn-primary mb-3"
        (click)="handleNext()"
        [disabled]="!steps[currentStepIndex].isValid || stepLoading"
      >
        {{ 'button.next' | translate }}
      </button>
    </div>

    <div>
      <button
        class="btn btn-warning me-3 mb-3"
        [class]="isLastStep ? 'me-3' : ''"
        (click)="deleteBooking()"
        [disabled]="stepLoading"
      >
        {{ 'button.cancel' | translate }}
      </button>
      <button
        *ngIf="isLastStep"
        [disabled]="isPayBtnClicked || stepLoading"
        class="btn btn-primary mb-3"
        (click)="doPayment()"
      >
        {{ 'button.pay-now' | translate }}
      </button>
    </div>
  </div>
</div>
